import React, { FC } from 'react'
import { Button } from '@/atoms/Button'
import { CloseIcon } from '@/atoms/Icons/CloseIcon'
import { Text } from '@/atoms/Text'
import { Modal } from '@/molecules/Modal'
import { useTranslate } from '@/utils/translate/translate-client'

interface Props {
  isOpen: boolean
  onClose: () => void
}
export const ErrorRefundedModal: FC<Props> = ({ isOpen, onClose }) => {
  const { t } = useTranslate('tickets')

  return (
    <Modal
      backgroundScreenColor="black"
      isOpen={isOpen}
      onClose={onClose}
      className="z-50 mx-auto"
      childWrapperClassName="!m-0 !p-0"
      panelClasses="bg-white !max-w-[361px] md:!max-w-[600px] !w-full !rounded-2xl !p-8 !pt-10 md:!p-10 md:!pt-12 relative"
      transition="appear"
    >
      <div className="absolute right-6 top-6 cursor-pointer rounded-full bg-core-gray-200 p-1" onClick={onClose}>
        <CloseIcon color="black" size={18} />
      </div>
      <div className="flex flex-col">
        <Text className="photon-title-lg md:photon-heading-xs" weight="bold">
          {t('reservationFailed', 'Reservation Failed')}
        </Text>

        <Text color="core-gray-700" className="photon-paragraph-sm md:photon-paragraph-md mt-4">
          {t(
            'reservationRefundedDescription',
            'We couldn’t complete your ticket reservation. Your payment has been fully refunded. Please try again.',
          )}
        </Text>

        <Button onClick={onClose} className="mt-8 md:mr-auto md:mt-10" variant="black">
          {t('tryAgainShowtimes', 'Try Again')}
        </Button>
      </div>
    </Modal>
  )
}
